import type { ZodTypeAny } from 'zod';
import { z } from 'zod';

import type { FieldDescriptor } from '../../types/common';

import { SingleSelectFieldElement } from './SingleSelectField';
import type { SingleSelectField } from './types';

const createValidationSchema = (field: SingleSelectField) => {
  let fieldSchema: ZodTypeAny = z.union([z.string(), z.number(), z.boolean()], {
    required_error: 'Please select an option',
  });

  if (field.validation?.isOptional) {
    fieldSchema = fieldSchema.optional();
  }

  return fieldSchema;
};

const Descriptor: FieldDescriptor<SingleSelectField> = {
  FieldComponent: SingleSelectFieldElement,
  name: 'SingleSelectField',
  createValidationSchema,
};

export default Descriptor;

export type { SingleSelectField as FieldType };
